import React, {useEffect, useState, useRef} from 'react';
import eyeClosed from '../../pics/icons/eyeClosed.png'; 
import eyeOpen from '../../pics/icons/eyeOpen.png'; 
import OptionButton from '../EncounterColumn/OptionButton';
import isPlayerImg from '../../pics/icons/isPlayerImg.png';
import isPetImg from '../../pics/icons/pet.PNG';
import FlagPole from './FlagWidget/FlagPole.js';
import EffectImg from '../../pics/icons/effectImg.png';
import { effectImgMap, conditionImgMap, addSign, COLOR_GREEN, COLOR_RED} from '../../constants.js';
import Effect from './Effect.js';
import EditAvatar from '../Statblock/EditAvatar.js';
import WidgetPopUp from './WidgetPopUp.js';
import TeamWidgetPopup from './FlagWidget/TeamWidgetPopup.js';
import DeathSaves from '../../../playerView/components/DeathSaves.js';

const colors = {
    0: "green",
    1: "orange",
    2: "brown",
}

const EncounterListItem = ({index, currentEncounter, creatureListItem, isTurn, setCurrentEncounter, handleUploadMonsterImage, selectedIndex, handleRemoveFromSelectedIndex, clickEncounterCreatureX, resort, socket}) => {
    // Track previous index for animation direction
    const [prevIndex, setPrevIndex] = useState(index);
    const [moveDirection, setMoveDirection] = useState(null); // 'up' | 'down' | null
    const animationRef = useRef(null); 

    useEffect(() => {
        clearTimeout(animation.current)

        if (prevIndex !== index) {
            setMoveDirection(prevIndex > index ? 'up' : 'down');
        } else {
            setMoveDirection(null);
        }

        animationRef.current = setTimeout((() => {
            setMoveDirection(null)
        }), 2000)

        setPrevIndex(index);
    }, [index, creatureListItem.creatureGuid]);

    const scrollRef = useRef(null);
    const [hidden, setHidden] = useState(creatureListItem.hidden);
    const [creature, setCreature] = useState(creatureListItem)
    const [isHovered, setIsHovered] = useState(false);

    const [maxHp, setMaxHp] = useState(creatureListItem.hit_points);
    const [currentHp, setCurrentHp] = useState(creatureListItem.hit_points_current);

    const [hpChange, setHpChange] = useState(0);
    const [openHpWidget, setOpenHpWidget] = useState(false);

    const [openTeamWidget, setOpenTeamWidget] = useState(false);

    const [isPlayer, setIsPlayer] = useState(creature.type === "player");
    const [isPet, setIsPet] = useState(creature.alignment === "pet");
    const [alignment, setAlignment] = useState(creature.alignment);
    const [borderColor, setBorderColor] = useState(creature.border);
    const [effects, setEffects] = useState(creature.effects);
    const [selected, setSelected] = useState(false)
    const [selectedPlace, setSelectedPlace] = useState(-1)
    const [shake, setShake] = useState(undefined);

    useEffect(() => {
        if(isTurn) {
            if (scrollRef.current) {
                scrollRef.current.scrollIntoView({ behavior: 'smooth', block: 'center'}); // 'smooth' for animated scroll, 'auto' for instant
            }
        }
    }, [isTurn]);

    useEffect(() => {
        // Only update if the arrays are actually different
        const isSame = effects.length === creatureListItem.effects.length &&
                    effects.every((e, i) => e === creatureListItem.effects[i]);
        
        if (!isSame) {
            setEffects(creatureListItem.effects);
        }
    }, [creatureListItem.effects]);

    useEffect(() => {
        if(shake) {
            setTimeout(() => {
                setShake(undefined)
            }, 1000)
        }
    }, [shake])

    useEffect(() => {
        const selectedIndexOf = selectedIndex.findIndex(obj => obj.index === index);
        setSelectedPlace(selectedIndexOf)
        setSelected(selectedIndexOf !== -1)
    }, [selectedIndex])

    useEffect(() => {
        setCreature(creatureListItem)
        // eslint-disable-next-line
    }, [creatureListItem, creatureListItem.initiative]);

    const handleCreatureChange = () => {
        setCurrentEncounter(prev => ({
            ...prev,
            creatures: [...prev.creatures.map((oldCreature) => {
                return oldCreature.creatureGuid === creature.creatureGuid ? creature : oldCreature;
            })]
        }));
    }

    // This useeffect is for checking changes from the statblock edit
    useEffect(() => {
        if(creatureListItem.hit_points !== creature.hit_points || creatureListItem.hit_points_current !== creature.hit_points_current) {
            setMaxHp(creatureListItem.hit_points)
            setCurrentHp(creatureListItem.hit_points_current)
        }
    // eslint-disable-next-line
    }, [creatureListItem.hit_points, creatureListItem.hit_points_current]);

    useEffect(() => {
        let newCreature = {
                ...creature, 
                alignment: alignment,
                type: isPlayer ? 'player' : 'monster',
                border: borderColor,
                hidden: hidden,
                effects: [...effects]
        }

        setCurrentEncounter(prev => ({
            ...prev,
            creatures: [...prev.creatures.map((oldCreature) => {
                return oldCreature.creatureGuid === newCreature.creatureGuid ? newCreature : oldCreature;
            })]
        }));
        
    // eslint-disable-next-line
    }, [alignment, isPlayer, isPet, borderColor, hidden, effects]);

    const openEditHpWidget = (openHp) => {
        setOpenHpWidget(!openHp)
    }

    const handleChangeHpCreature = (type, event) => {
        event.stopPropagation()
        let hpNum = hpChange;
        if(type === 'damage') {
            if(creature.hit_points_temp > 0) {
                let tempHpRemainder = creature.hit_points_temp - hpChange
                if(tempHpRemainder <= 0) {
                    hpNum = Math.abs(tempHpRemainder)
                    creature.hit_points_temp = 0
                } else {
                    hpNum = 0
                    creature.hit_points_temp = tempHpRemainder
                }

            }

            hpNum *= -1                
        }
        
        creature.hit_points_current = parseInt(creature.hit_points_current) + hpNum

        if(creature.hit_points_current > creature.hit_points)
            creature.hit_points_current = creature.hit_points

        //hit_points | hit_points_current | hit_points_temp | hit_points_override
        socket.emit('playerHpChange', {hit_points_current: creature.hit_points_current, hit_points_temp: creature.hit_points_temp}, creature.creatureGuid, "dm");

        setOpenHpWidget(!openHpWidget)
        setCurrentHp(creature.hit_points_current)
        setCreature({...creature})
        handleCreatureChange()
    }

    const handleOverrideHp = (event) => {
        if(!isNaN(event.target.value)) {
            let override = parseInt(event.target.value) || 0
        
            // Set override in creature
            creature.hit_points_override = override
            // Find old diff between current and max
            let dif = creature.hit_points - creature.hit_points_current
            creature.hit_points = override === 0 ? creature.hit_points_default : override
            creature.hit_points_current = creature.hit_points - dif
            
            setMaxHp(creature.hit_points)
            setCurrentHp(creature.hit_points_current)
            setCreature({...creature})
            handleCreatureChange()
        }
    }

    const submitOverRideHpChange = () => {
        //hit_points | hit_points_current | hit_points_temp | hit_points_override
        socket.emit('playerHpChange', {
            hit_points: creature.hit_points,
            hit_points_current: creature.hit_points_current,
            hit_points_override: creature.hit_points_override,
        }, creature.creatureGuid, "dm");
        handleCreatureChange()
    }

    const handleChangeName = (event, send = false) => {
        let newName = event.target.value
        if(creature.name !== newName) {
            setCreature({...creature, name: newName})
        }

        if(send) {
            socket.emit("creatureNameChange", newName, creature.creatureGuid, "dm")
            currentEncounter.creatures[index].name = newName
            resort()
        }
    }

    const handleTempHp = (event) => {
        if(!isNaN(event.target.value)) {
            let tempHp = parseInt(event.target.value)
            creature.hit_points_temp = isNaN(tempHp) ? 0 : tempHp
            setCreature({...creature})
            handleCreatureChange()
        }
    }

    const submitTempHpChange = () => {
        //hit_points | hit_points_current | hit_points_temp | hit_points_override
        socket.emit('playerHpChange', {hit_points_temp: creature.hit_points_temp}, creature.creatureGuid, "dm");
        handleCreatureChange()
    }

    const handleHpChange = (event) => {
        if(!isNaN(event.target.value)) { 
            let input = event.target.value; 
            setHpChange(input === '' ? '' :  parseInt(event.target.value)) 
        }
    }

    const handleInitiativeChange = (event) => {
        if(!isNaN(event.target.value)) {
            let init = parseInt(event.target.value)
            if(creature.initiative !== init) {
                creature.initiative = isNaN(init) ? "" : init       
                setCreature({...creature})
            }
        }
    }
    
    const handleInitiativeCheck = () => {
        let init = creature.initiative === "" ? 0 : creature.initiative
        socket.emit('creatureInitiativeChange', init, creature.creatureGuid, "dm");
        currentEncounter.creatures[index].initiative = init
        resort()
    }    
    
    const handleHideEnemy = (event) => {
        event.stopPropagation()
        socket.emit('creatureHiddenToggle', !hidden, creature.creatureGuid, "dm");
        setHidden(!hidden)
    }  
    
    const handleAlignmentChange = (team) => {
        // If the creature is a pet and the new team is 'neutral' or 'enemy'
        if (team === 'neutral' || team === 'enemy') {
            setIsPet(false); // Remove pet status
        }

        // Only allow ally click if its not a pet
        if ((!isPet && team === 'ally') || team === 'neutral' || team === 'enemy') {
            setAlignment(team);
            socket.emit('creatureAlignmentChange', team, creature.creatureGuid, "dm");
        }
    };

    const handleTeamColorChange = (newBorderColor) => {
        if(newBorderColor.hex !== borderColor) {
            setBorderColor(newBorderColor.hex)
            socket.emit('creatureBorderColorChange', newBorderColor.hex, creature.creatureGuid, "dm");
        }
    };

    const handleCheckboxChange = (event) => {
        let checked = event.target.checked
        setIsPlayer(checked);

        if(checked && creature.alignment === 'pet') {
            setIsPet(false)
            setAlignment('ally')
            socket.emit('creatureAlignmentChange', 'ally', creature.creatureGuid, "dm");
        }

        socket.emit('creatureIsPlayerChange', checked, creature.creatureGuid, "dm");
        handleCreatureChange()
    };

    const handlePetCheckboxChange = (event) => {
        let checked = event.target.checked
        let team = checked ? 'pet' : 'ally'

        setIsPet(checked);
        if(checked && isPlayer) {
            setIsPlayer(false)
            socket.emit('creatureIsPlayerChange', false, creature.creatureGuid, "dm");
        }

        setAlignment(team);
        socket.emit('creatureAlignmentChange', team, creature.creatureGuid, "dm");
    };

    const handleTeamChangeWidget = (openReturned) => {
        setOpenTeamWidget(openReturned)
    }

    const handleArmorClassChange = (event, send = false) => {
        if(!isNaN(event.target.value)) {
            setCreature({...creature, armor_class: event.target.value});
            if(send) {
                socket.emit('creatureArmorClassChange', creature.armor_class, creature.creatureGuid, "dm");
                handleCreatureChange()
            }
        }
    }

    const handleHighlight = (e) => {
        e.target.select();
    };

    const updateCreatureEffects = (event, effect) => {
        event.stopPropagation(); 
        const alreadyExists = effects.some(e => e === effect);
        let updatedEffects = []
        if(alreadyExists) {
            updatedEffects = effects.filter(e => e !== effect)
        } else {
            updatedEffects = [...effects, effect]
        }

        setEffects(updatedEffects)
        socket.emit('creatureEffectChange', effect, alreadyExists ? "remove" : "add", creature.creatureGuid, "dm");
    };

    const handleClick = (index) => {
        if(!creatureListItem?.dnd_b_player_id)
            handleRemoveFromSelectedIndex(index, true); // Remove last column
        else {
            setShake(index)
        }
    };


    let isDead = creature.hit_points_current <= 0
    let isBloodied = creature.hit_points_current/creature.hit_points < .55
    let color = "rgb(62, 172, 74)"
    if(isDead) {
        color = "grey"
    } else if(isBloodied) {
        // if 0-.25 then red, if .25-.55 then orange
        color = .25 < creature.hit_points_current/creature.hit_points ? "orange" : "red"
    }

    let hpStyle = {color: color, borderColor: color}
    let effectsCount = effects.length > 0 ? `x${effects.length}` : ''
    let teamColor = COLOR_GREEN
    if (alignment === "enemy") teamColor = COLOR_RED
    else if (alignment === "neutral") teamColor = '#999999'

    let invis = currentEncounter.hideAll;
    // If hideAll === true then dont check anything else
    if(creature.type !== "player" && !invis) {
        if(creature.alignment === "ally" || creature.alignment === "pet") {
            invis = hidden
        } else {
            invis = hidden || currentEncounter.hideEnemies;
        }
    }

    // Only one animation is allowed so switch it if needs to shake
    let animation = shake !== index ? {animation: isTurn ? 'shadowPulseTurn 2s ease-in-out infinite' : ''} : {}

    return (
            <li 
                key={creature.creatureGuid}
                className={`listItem ${shake === index ? "alreadySelected" : ""}`}
                onClick={() => handleClick(index)}
                style={{
                    border: isTurn ? '2px solid rgba(0, 122, 130)' : '',
                    ...animation,
                    opacity: invis ? '.5' : '1'
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                ref={scrollRef}
            >   
                <div 
                    className={`encounterCreatureContainer animated-box${moveDirection === 'up' ? ' slide-up' : moveDirection === 'down' ? ' slide-down' : ''}`}
                    style={{
                        backgroundImage: `linear-gradient(45deg, ${borderColor} 25%, ${isHovered ? `#bfbba6` : `#cfc9a8`} 50%)`,
                        backgroundSize: '200% 200%',
                        backgroundPosition: isHovered ? '20% 20%':'50% 50%',
                        boxShadow: `${isHovered ? 'inset 0px 0px 0px 0px #434343' : 'inset 0px 0px 6px 0px #434343'}`,
                        transition: 'background-position .5s, box-shadow 0.15s ease',
                    }} 
                >
                    <div className='encounterCreatureLeftContainer' >
                        <div className='initiativeInputContainer'>
                            <input style={{borderLeft: `6px solid ${teamColor}`}} className='initiativeInput' onFocus={handleHighlight} onBlur={handleInitiativeCheck} type='text' value={creature.initiative} onChange={handleInitiativeChange} onClick={(event) => event.stopPropagation()}/>
                            <div className='initiativeModToken'>{creature.dexterity === null ? "+0" : addSign(Math.floor((creature.dexterity-10)/2))}</div>
                        </div>
                        <EditAvatar handleUploadMonsterImage={handleUploadMonsterImage} creature={creature} column={"encounter"}/>
                        <div className='listItemMiddleStats'>
                            <div className='nameInputContainer'>
                                <input className='nameInput' type='text' value={creature.name} onChange={handleChangeName} onBlur={(e) => handleChangeName(e, true)} onClick={(event) => event.stopPropagation()}/>
                                {selected && <div className='selectedIndicater siListItem' style={{backgroundColor: colors[selectedPlace]}}>{selectedPlace+1}</div>}

                            </div>
                            <div className='middleStatsContainer'>
                                <label htmlFor='ac' className='middleStatsLabel'>AC</label>
                                <input id='ac' className='middleStatsInput' onFocus={handleHighlight} type='numeric' value={creature.armor_class} onChange={handleArmorClassChange} onBlur={(e) => handleArmorClassChange(e, true)} onClick={(event) => event.stopPropagation()}/>
                            
                                {moveDirection !== null &&
                                    <svg width="16" height="16" viewBox="0 0 16 16" style={{
                                            verticalAlign: "middle",
                                            transform: moveDirection === "up" ? "rotate(180deg)" : "rotate(0deg)",
                                            minWidth: "16px",
                                            minHeight: "16px"
                                        }}>
                                        <polyline points="4,6 8,10 12,6" fill="none" stroke={moveDirection === "up" ? "#2e552dff" : "#ce0c0cff"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                }
                            </div>
                        </div>
                    </div>

                    <div className='listItemOptions'>
                        <div className='optionHide'>
                            <WidgetPopUp 
                                onOpenChange={handleTeamChangeWidget} 
                                trigger={
                                    <FlagPole flagColor={borderColor} teamColor={teamColor} isWidgetOpen={openTeamWidget} />
                                }
                                popUp={
                                    <TeamWidgetPopup borderColor={borderColor} handleTeamColorChange={handleTeamColorChange} handleAlignmentChange={handleAlignmentChange} isPlayer={isPlayer} handleCheckboxChange={handleCheckboxChange} isPet={isPet} handlePetCheckboxChange={handlePetCheckboxChange} alignment={alignment}/>
                                }
                                popOverClass={'editTeamContainer'}
                                alignOffset={-4}
                                sideOffset={8}
                            />
                        </div>
                        <div className={`eyeball ${hidden ? '' : 'optionHide'}`}>
                            <OptionButton src={hidden ? eyeClosed : eyeOpen}  message={(hidden ? "Hidden" : "Visible")} onClickFunction={handleHideEnemy} imgClassName={'option-no-margin'} />
                        </div>
                        <div>
                            <button className='encounterCreatureX optionHide' onClick={(event) => clickEncounterCreatureX(event, creature, index)}>
                            ❌
                            </button>
                        </div>
                        <div className={effects.length === 0 ? 'optionHide' : ''}>
                            <WidgetPopUp 
                                trigger={
                                    <div style={{position: "relative"}}>
                                        {effectsCount &&
                                            <div className='effectsCounter'>{effectsCount}</div>
                                        }
                                        <OptionButton src={EffectImg} message={`Effects ${effectsCount}`} imgStyle={{margin: 0, animation: effectsCount ? 'shadowPulse 4s ease-in-out infinite' : ''}}/>
                                    </div>
                                }
                                popUp={
                                    <div className="dmVieweffectsBarContainer" style={{textWrap: "pretty"}}>
                                        <div className="effectContainerFlag"/>
                                        <div className="effectTitles"><b>Spell Effects</b></div>
                                        <div className="effectsBar" onClick={(event) => event.stopPropagation()} >
                                            {Object.entries(effectImgMap).map(([effect, image]) => (
                                                <Effect 
                                                    key={creature.creatureGuid + effect} 
                                                    currentEffects={effects} 
                                                    updateCreatureEffects={updateCreatureEffects} 
                                                    effect={effect} 
                                                    image={image}
                                                />
                                            ))}
                                        </div>
                                        <hr className="editLineSeperator" style={{marginBottom: 0}}/>
                                        <div className="effectTitles"><b>Conditions (Work In Progress)</b></div>
                                        <div className="effectsBar" onClick={(event) => event.stopPropagation()} >
                                            {Object.entries(conditionImgMap).map(([condition, image]) => (
                                                <Effect 
                                                    key={creature.creatureGuid + condition} 
                                                    currentEffects={effects} 
                                                    updateCreatureEffects={updateCreatureEffects} 
                                                    effect={condition} 
                                                    image={image}
                                                />
                                            ))}
                                        </div>
                                        <div className="monsterSearchDetailText"><b>NOTE</b>: If Creature is a DnDBeyond Import</div>
                                        <div className="monsterSearchDetailText">Dm selected Conditions will be overwritten during the auto updates. </div>
                                    </div>
                                }
                                popOverClass={'editTeamContainer'}
                                alignOffset={-4}
                                sideOffset={8}
                            />
                        </div>
                    </div>
                    {maxHp !== null ? 
                        <WidgetPopUp 
                            disabled={creature.dnd_b_player_id}
                            triggerClass={'hpButtonTrigger'}
                            trigger={
                                <div className='encounterCreaturesHpContainer'>
                                    <button 
                                        className='encounterCreaturesHp'
                                        style={{
                                            backgroundImage: `linear-gradient(to top, ${hpStyle.color} -50%, white 45%)`,
                                            ...hpStyle
                                        }}
                                    >
                                        {currentHp}
                                        <span>/</span>
                                        {maxHp}
                                        {creature.hit_points_temp !== 0 && (
                                            <span className='tempHp'> (+{creature.hit_points_temp}) </span>
                                        )}
                                    </button>
                                    {creature.type === "player" ? 
                                        <OptionButton src={isPlayerImg} message={'Player Token'} wrapperClassName={'hpButtonPlayerOverlay'} imgStyle={{margin: 0}} onClickFunction={(event) => openEditHpWidget(event)}/>
                                    :
                                        <>
                                            {creature.alignment === "pet" && 
                                                <OptionButton src={isPetImg} message={'Pet Token'} wrapperClassName={'hpButtonPlayerOverlay'} imgStyle={{margin: 0}} onClickFunction={(event) => openEditHpWidget(event)}/>
                                            }
                                        </>
                                    }
                                    
                                </div>
                            }
                            popUp={
                                <>
                                    <div className="hpContainerFlag" style={{bottom: creature.hit_points_current <= 0 ? "10%" : "15%"}}/>
                                    <div>
                                        <div className='extraHpInputs' >
                                            <label className='hpTitle tempHp' style={{color: creature.hit_points_temp === 0 ? 'grey' : ''}} htmlFor='temphp'><strong>Temp HP</strong></label>
                                            <input id='temphp' type='number' className='editStatsInputExtra tempHp' value={creature.hit_points_temp} style={{color: creature.hit_points_temp === 0 ? 'grey' : ''}} onFocus={handleHighlight} onChange={handleTempHp} onBlur={submitTempHpChange}/>
                                        </div>
                                        <div className='extraHpInputs'>
                                            <label className='hpTitle' htmlFor='override' style={{color: creature.hit_points_override === 0 ? 'grey' : ''}}><strong>Override HP</strong></label>
                                            <input id='override' type='number' className='editStatsInputExtra' value={creature.hit_points_override} style={{color: creature.hit_points_override === 0 ? 'grey' : ''}} onFocus={handleHighlight} onChange={handleOverrideHp} onBlur={submitOverRideHpChange}/>
                                        </div>
                                    </div>
                                    <hr className='hplineSeperator'/>
                                    <div className='editHpContainer'>
                                        <button className='editHpButton healButton' onClick={(event) => handleChangeHpCreature("heal", event)}>HEAL</button>
                                        <input className='editStatsInput' value={hpChange} onChange={handleHpChange} autoFocus onFocus={handleHighlight}/>
                                        <button className='editHpButton damageButton' onClick={(event) => handleChangeHpCreature("damage", event)}>DAMAGE</button>
                                    </div>
                                    <hr className='hplineSeperator'/>

                                    {creature.type === "player" && creature.hit_points_current <= 0 && 
                                        <div>
                                            <div style={{color: "#822000"}}><strong>Death Saves</strong></div>
                                            <div style={{background: "#ddd3a3ff", border: "2px solid grey", borderRadius: "5px", padding: "2px 2px 2px 0px", margin: "0px 6px 4px 0px"}}>
                                                <DeathSaves creatueGuid={creature.creatureGuid} pass={creature.death_saves_success_count} fail={creature.death_saves_failure_count} socket={socket}/>
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                            popOverClassContainer={'hpPopover'}
                            side='left'
                            sideOffset={25}
                            alignOffset={-15}
                        />
                    :
                        <div className='encounterCreaturesHp'/>
                    }
                </div>
            </li>
           
  );
}

export default EncounterListItem;